import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import InputText from '@Components/Fields/InputText'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import { CreatePasswordSceneChildrenProps } from '@Scenes/UserRegistrationScenes/CreatePasswordScene'

const ConfirmSMSCode = (props: CreatePasswordSceneChildrenProps) => {
    const { createPasswordStore, popupStore } = useContext(StoresContext)

    const handlePasswordValue = (value: string, id: string) => {
        createPasswordStore.getValue(value, id)
    }

    const submitMfaCode = async (e: any) => {
        e.preventDefault()
        props.setLoading(true)
        await createPasswordStore.submitMfaCode().catch((error: any) => {
            popupStore.setAlertData(
                'MFA code entered is expired or invalid. Please contact Support for a new code.',
                true
            )
            props.setLoading(false)
        })
        props.setLoading(false)
    }

    return (
        <div className="global-container">
            <form className="config-mfa-form" onSubmit={submitMfaCode}>
                <div className="confirm-phone-mfa">
                    <h3>Confirm Phone MFA</h3>
                    <p>
                        We have texted a code to <strong>{createPasswordStore.formattedPhoneNumber}</strong>. Please
                        enter that code in the space below.
                    </p>
                    <p className="disclaimer">NOTE: MFA codes expire after 15 minutes.</p>
                    <InputText
                        mainColor
                        id="code"
                        onChange={handlePasswordValue}
                        label="Code"
                        required
                        errorMessage={createPasswordStore.codeError}
                        autoComplete="off"
                        assistiveText=""
                        autoFocused
                    />

                    <Button mainColor type="primary" disabled={props.loading}>
                        Submit Code
                    </Button>
                </div>
            </form>
        </div>
    )
}

export default observer(ConfirmSMSCode)
